import { useSelector } from 'react-redux';

import {
  QUICK_COLLECT_MAX_AMOUNT,
  QUICK_COLLECT_MIN_AMOUNT
} from '@constants/generic';

interface QuickCollectAmountLimits {
  minAmount: number;
  maxAmount: number;
}

// Reads the quick-collect amount bounds from the org/app config API, falling
// back to the generic constants when the config has not loaded.
const useQuickCollectAmountLimits = (): QuickCollectAmountLimits => {
  const { orgConfig, appConfig } = useSelector((state: any) => state.user);

  const maxAmount =
    orgConfig?.quick_collect_amount_max ||
    appConfig?.quick_collect_amount_max ||
    QUICK_COLLECT_MAX_AMOUNT;
  const minAmount =
    orgConfig?.quick_collect_amount_min ||
    appConfig?.quick_collect_amount_min ||
    QUICK_COLLECT_MIN_AMOUNT;

  return { minAmount: Number(minAmount), maxAmount: Number(maxAmount) };
};

export default useQuickCollectAmountLimits;
